<template>
  <div class="draw" :class="['draw--' + mode, isResult? 'isResult': '', isSuccess? 'isSuccess': '']" :style="{'background-image':'url(' + drawBgUrl + ')'}">

    <div class="c-header">
      <div class="c-header__bg">
        <img src="images/draw/bg/bg_stone.png" alt="">
      </div>
      <div class="c-header__logo">
        <img src="images/draw/common/header_logo.png" alt="">
      </div>
    </div>

    <div v-if="!isResult">
      <div class="draw__text draw__text--0" v-if="mode == 0">
        <img src="images/draw/text/text_8.png" alt="">
      </div>
      <div class="draw__text draw__text--1" v-if="mode == 1">
        <img src="images/draw/text/text_32.png" alt="">
      </div>
    </div>

    <div class="draw__input" v-if="!isResult">
      <div class="draw__sample" v-if="!isDebug && mode == 0">
        <img src="images/draw/sample_1.png" alt="">
      </div>
      <div class="draw__sample" v-if="!isDebug && mode == 1">
        <img src="images/draw/sample_2.png" alt="">
      </div>

      <div class="draw__canvas-wrap" v-if="isDebug">
        <canvas width="500" height="500" ref="canvas" class="draw__canvas"></canvas>
      </div>

      <div class="draw__deco" v-if="mode == 1">
        <div class="draw__deco--1" v-if="!isInputError">
          <img src="images/draw/other/comic_deco_1.png" alt="">
        </div>
        <div class="draw__deco--2">
          <img src="images/draw/other/comic_deco_2.png" alt="">
        </div>
      </div>

      <div class="draw__textfield">
        <!-- <div class="draw__field u-pixel10">{{inputText}}</div> -->
        <textarea v-model="inputText" placeholder="" class="draw__textarea u-pixel10" ref="textarea" v-if="!isInputError"></textarea>

        <div class="draw__text-error--0" v-if="isInputError && mode == 0">
          <img src="images/draw/text/text_error_8.png" alt="">
        </div>
        <div class="draw__text-error--1" v-if="isInputError && mode == 1">
          <img src="images/draw/text/text_error_32.png" alt="">
        </div>
      </div>

      <div class="draw__btns">
        <button class="draw__btn draw__btn--0" v-on:click="setNum(0)">
          <img src="images/draw/btn/btn_0.png" alt="0" v-if="mode == 0">
          <img src="images/draw/btn/btn_0_red.png" alt="0" v-if="mode == 1">
        </button>
        <button class="draw__btn draw__btn--1" v-on:click="setNum(1)">
          <img src="images/draw/btn/btn_1.png" alt="1" v-if="mode == 0">
          <img src="images/draw/btn/btn_1_red.png" alt="1" v-if="mode == 1">
        </button>
        <button class="draw__btn draw__btn--clear" v-on:click="clear">
          <img src="images/draw/btn/btn_retry.png" alt="clear" v-if="mode == 0">
          <img src="images/draw/btn/btn_retry_red.png" alt="clear" v-if="mode == 1">
        </button>
      </div>
      <div class="draw__enter">
        <button v-on:click="startCheck" class="c-btn--pixel u-pixel10">→ プログラムをロードする!</button>
      </div>
    </div>

    <transition name="fade">
      <div class="draw__anime anime" :class="['anime--' + mode]" v-if="isAnime" :style="{'background-image':'url(' + animeBgUrl + ')'}">
        <div class="c-header">
          <div class="c-header__bg">
            <img src="images/draw/bg/bg_stone.png" alt="">
          </div>
          <div class="c-header__logo">
            <img src="images/draw/common/header_logo.png" alt="">
          </div>
        </div>

        <div class="anime__inner">
          <div class="anime__comics-wrap">
            <div class="anime__comics">
              <div class="anime__comic anime__comic--1 js-anime-comic--1" ref="comic1">
                <img src="images/draw/other/comic_0.png" alt="">
              </div>
              <div class="anime__comic anime__comic--2 js-anime-comic--2" ref="comic2">
                <img src="images/draw/other/comic_1.png" alt="">
              </div>
              <div class="anime__comic anime__comic--3 js-anime-comic--3" ref="comic3">
                <img src="images/draw/other/comic_0.png" alt="">
              </div>
              <div class="anime__comic anime__comic--4 js-anime-comic--4" ref="comic4">
                <img src="images/draw/other/comic_1.png" alt="">
              </div>
            </div>

          </div>
          <div class="anime__num-wrap">
            <div class="anime__num anime__num--1" ref="num1">
              <!-- 0 -->
              <img src="images/draw/other/number0_1_0.png" alt="" v-if="mode == 0">
              <img src="images/draw/other/number0_1_1.png" alt="" v-if="mode == 1">
            </div>
            <div class="anime__num anime__num--2" ref="num2">
              <!-- 0 -->
              <img src="images/draw/other/number0_2_0.png" alt="" v-if="mode == 0">
              <img src="images/draw/other/number0_2_1.png" alt="" v-if="mode == 1">
            </div>
            <div class="anime__num anime__num--3" ref="num3">
              <!-- 0 -->
              <img src="images/draw/other/number0_3_0.png" alt="" v-if="mode == 0">
              <img src="images/draw/other/number0_3_1.png" alt="" v-if="mode == 1">
            </div>
            <div class="anime__num anime__num--4" ref="num4">
              <!-- 1 -->
              <img src="images/draw/other/number1_1_0.png" alt="" v-if="mode == 0">
              <img src="images/draw/other/number1_1_1.png" alt="" v-if="mode == 1">
            </div>
            <div class="anime__num anime__num--5" ref="num5">
              <!-- 1 -->
              <img src="images/draw/other/number1_2_0.png" alt="" v-if="mode == 0">
              <img src="images/draw/other/number1_2_1.png" alt="" v-if="mode == 1">
            </div>
            <div class="anime__num anime__num--6" ref="num6">
              <!-- 1 -->
              <img src="images/draw/other/number1_3_0.png" alt="" v-if="mode == 0">
              <img src="images/draw/other/number1_3_1.png" alt="" v-if="mode == 1">
            </div>
          </div>
          <div class="anime__text u-pixel10">プログラムをロード中!</div>
        </div>
      </div>
    </transition>

    <component :is="resultView" v-if="isResult" :inputText="inputText" :sampleData="sampleData" :mode="mode" @transition="toScene"></component>

    <div class="draw__error error" v-if="isInputError" v-on:click="closeError">
      <div class="error__comic">
        <img src="images/draw/other/comic_error.png" alt="">
      </div>
    </div>

    <button v-on:click="toTop" class="c-btn--top">
      <img src="images/draw/btn/btn_return_top.png" alt="離脱してTOPに戻る">
    </button>

    <footer class="c-footer">
      <div class="c-footer__img">
        <img src="images/top/copyright.png" alt="©米スタジオ・Boichi／集英社">
      </div>
    </footer>
  </div>

</template>

<script>

import * as PIXI from 'pixi.js'
import { gsap } from 'gsap'
import { PixiPlugin } from 'gsap/PixiPlugin'

import DrawResult from '@/components/DrawResult.vue'
import {DrawCanvas} from '@/assets/js/DrawCanvas.js'

gsap.registerPlugin(PixiPlugin)
PixiPlugin.registerPIXI(PIXI)
gsap.defaults({ overwrite: 'auto' })

export default {
  props: ['mode'],
  components: {
    DrawResult,
    drawBgUrl: "images/draw/bg/bg_blue.jpg",
    animeBgUrl: "images/draw/bg/bg_blue.jpg"
  },
  data: function() {
    return {
      // mode: 0, // 0:8*8, 1:16*16
      container: null,
      containerSample: null,
      rectGraphics: [],
      rectGraphicsSample: [],
      inputText: "",
      sampleData: "",
      palette: {
        "0": 0xFFFFFF,
        "1": 0x000000
      },

      isResult: false,
      resultView: 'DrawResult',

      isAnime: false, // 演出
      isInputError: false, // 入力文字数エラー
      isSuccess: false, // 成功

      isDebug: false,
    }
  },
  created() {
    if(this.mode == 0) {
      this.sampleData = "0000011100001111011110110111011000111100100111000000110010100000"
      this.digit = {x: 8, y: 8}
    }else {
      this.sampleData = "0000000000000000000000010000000000000000000000000000011100000000000000000000000000001001000000000000000000000000111100010000000000000000000000111100000010000000010000000111110010100100100000001100000110000000000011000100000011000010000000000001110001000000110011001100000000111100001000001001000111100000011111000010000001100000100000000000000000010000100000000000001111111100000100001000000000011111111111000000100011000000011111111111100000100100110100001111111111111000011001001100110001111111111110001111101011011100000111111111100001110010111010100000000000000000001000011110000000000011111100000000000001100000000000011110000000000011011100000000000011100001001111000111000000000000011010111100000001110000000000000000011100000000011110010100010000001100000000000011100110000110001100000000000000111011110011101100000000000000001110010000011100000000000000000011110000001100000000000000000000111100001100000000000000000000000110111100000000000000000000000001010000000000000000000000000000011100000000000000000000000000"
      this.digit = {x: 32, y: 32}
    }
    this.rectSize = 500 / this.digit.x

    if(this.mode == 0) {
      this.drawBgUrl = "images/draw/bg/bg_blue.jpg"
      this.animeBgUrl = "images/draw/bg/bg_blue.jpg"
    }else {
      this.drawBgUrl = "images/draw/bg/bg_red.jpg"
      this.animeBgUrl = "images/draw/bg/bg_red.jpg"
    }
  },
  mounted() {


    // テスト用Canvas
    if(this.isDebug) {
      const app = new PIXI.Application({
        width: 500, 
        height: 500, 
        view: this.$refs.canvas,
        backgroundColor: 0xFFFFFF, 
        resolution: window.devicePixelRatio || 1,
      });
      this.container = new PIXI.Container()
      app.stage.addChild(this.container);

      this.containerSample = new PIXI.Container()
      app.stage.addChild(this.containerSample);

      let dc = new DrawCanvas(this.digit, this.rectSize);

      // Line
      let lines = dc.drawLine(this.container)
      console.log(lines)
      

      // Rect
      for(let i = 0; i < this.digit.x * this.digit.y; i++) {
        let g = new PIXI.Graphics()
        let y = Math.floor(i / this.digit.y)
        g.beginFill(0xffffff)
        g.drawRect((i - y * this.digit.y) * this.rectSize, y * this.rectSize, this.rectSize, this.rectSize)
        g.alpha = 0
        g.tint = 0xFFFFFF
        g.endFill()
        
        this.rectGraphics[i] = g
        this.container.addChild(this.rectGraphics[i])
      }

      this.draw()
    }

  },
  methods: {
    setNum(num) {
      this.inputText += num
    },
    clear() {
      this.inputText = ""
    },
    draw() {
      for(let i = 0; i < this.rectGraphics.length; i++) {
        this.rectGraphics[i].alpha = 0
      }

      for(let i = 0; i < this.inputText.length; i++) {
        this.rectGraphics[i].tint = this.palette[this.inputText[i]]
        this.rectGraphics[i].alpha = 1
      }
    },

    // sampleDraw() {
      
    //   for(let i = 0; i < this.digit.x * this.digit.y; i++) {

    //     if(this.sampleData[i] == "1") {
    //       let g = new PIXI.Graphics()
    //       let y = Math.floor(i / this.digit.y)
    //       g.beginFill(0xffffff)
    //       g.drawRect((i - y * this.digit.y) * this.rectSize, y * this.rectSize, this.rectSize, this.rectSize)
    //       g.alpha = 1
    //       g.tint = 0x000000
    //       g.endFill()
          
    //       this.rectGraphicsSample.push(g)
    //       this.containerSample.addChild(g)
    //     }
        
    //   }
      
    //   this.hideSampleDot(1)
    // },

    // showSampleDot(_delay = 0) {
    //   // 見本を表示
    //   gsap.to(this.rectGraphicsSample, { 
    //     duration: 1, 
    //     delay: _delay, 
    //     pixi: {alpha: 1}})
    // },
    
    // hideSampleDot(_delay = 0) {
    //   // 見本を隠す
    //   gsap.to(this.rectGraphicsSample, { 
    //     duration: 1, 
    //     delay: _delay, 
    //     onComplete: () => {
    //       this.showRandomDot()
    //     }, 
    //     pixi: {alpha: 0}})
    // },

    // showRandomDot() {
    //   // 見本のドットからランダムにアニメーション表示
    //   let randoms = [];
    //   let randomDotNum = this.random(1, 4)
    //   while(randoms.length < randomDotNum) {
    //     let r = this.random(0, this.rectGraphicsSample.length)
    //     if(!randoms.includes(r)) {
    //       randoms.push(r)
    //     }
    //   }

    //   let selectDots = []
    //   randoms.forEach(i => {
    //     selectDots.push(this.rectGraphicsSample[i])
    //   })

    //   gsap.to(selectDots, { 
    //     duration: 1.5, 
    //     delay: 0.3, 
    //     repeat: 1, 
    //     yoyo: true, 
    //     onComplete: () => {
    //       this.showRandomDot()
    //     }, 
    //     pixi: {alpha: 1}})
    // },

    // random(min, max) {
    //   return Math.floor(Math.random() * (max - min)) + min
    // },

    startCheck() {

      // 文字数比較
      if(this.sampleData.length != this.inputText.length) {
        // 足りないエラー
        this.isInputError = true
        return
      }

      if(this.sampleData == this.inputText) {
        this.isSuccess = true
      }

      // 演出開始
      this.isAnime = true
      this.$nextTick(() => {
        this.animeStart()
      })

    },
    animeStart() {
      console.log("animeStart", this.$refs)
      let tl = gsap.timeline({
        repeat: 0,
        paused: false,
      })
      
      tl.set(this.$refs.comic1, {autoAlpha: 1})
      .set(this.$refs.comic2, {autoAlpha: 0})
      .set(this.$refs.comic3, {autoAlpha: 0})
      .set(this.$refs.comic4, {autoAlpha: 0})
      .set([this.$refs.num1, this.$refs.num2, this.$refs.num3, this.$refs.num4, this.$refs.num5, this.$refs.num6], {autoAlpha: 0})


      tl.to(this.$refs.comic2, {
        delay: 0.7, autoAlpha: 1, duration: 0.7,
        onComplete: () => {
          if(this.mode == 1 && this.isSuccess) {
            this.drawBgUrl = "images/draw/bg/bg_space.jpg"
          }
          this.isResult = true
        }
      })
      .to(this.$refs.comic3, {
        autoAlpha: 1, duration: 0.7})
      .to(this.$refs.comic4, {
        autoAlpha: 1, duration: 0.7, 
        onComplete: () => {
          setTimeout(() => {
            this.isAnime = false
          }, 400);
        }}
      )

      gsap.to([this.$refs.num1, this.$refs.num2, this.$refs.num4], {
        delay: 0.5, autoAlpha: 1, duration: 3, y: -80
      })
      gsap.to(this.$refs.num4, {
        delay: 0.9, autoAlpha: 1, duration: 2.5, y: -80
      })
      gsap.to([this.$refs.num3, this.$refs.num6], {
        delay: 1.7, autoAlpha: 1, duration: 2.5, y: -80
      })
      gsap.to([this.$refs.num5], {
        delay: 2.0, autoAlpha: 1, duration: 1.8, y: -80
      })
      

    },


    closeError() {
      this.isInputError = false
    },

    toTop() {
      this.$emit("transition", "Top")
    },
    
    toScene(...args) {
      this.$emit("transition", args[0])
    }
  },
  computed: {
    canvas() {
        return this.$refs.canvas;
    },
    ctx() {
        return this.canvas.getContext('2d');
    },
  },
  watch: {
    inputText() {
      // this.hideSampleDot()

      this.inputText = this.inputText.replace(/\r?\n/g,"")
      this.inputText = this.inputText.replace(/[^0-1]/gi, '')

      while(this.digit.x * this.digit.y < this.inputText.length) {
        this.inputText = this.inputText.slice(0, -1)
      }

      this.$refs.textarea.scrollTo(0, this.$refs.textarea.scrollHeight)

      if(this.isDebug) {
        this.draw()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.draw {
  background-position-x: center;
  background-position-y: top;
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  position: relative;
  width: 100%;


  &__text {
    margin: 0 auto get_percent(10px);
    position: relative;
    z-index: 10;

    &--0 {
      width: get_percent(calc_retina3(675px));
    }

    &--1 {
      width: get_percent(calc_retina3(743px));
    }
  }

  &__input {
    position: relative;
    z-index: 10;
  }

  &__sample {
    height: get_percent(calc_retina3(801px));
    margin: 0 auto 20px;
    position: relative;
    width: get_percent(calc_retina3(801px));
  }

  &__canvas-wrap {
    background: #FFF;
    height: get_percent(calc_retina3(801px));
    margin: 0 auto 20px;
    position: relative;
    width: get_percent(calc_retina3(801px));
  }

  &__canvas {
    height: 100%;
    position: relative;
    vertical-align: bottom;
    width: 100%;
    z-index: 10;
  }

  &__textfield {
    background: url(../assets/images/textfield.png) top left no-repeat;
    background-attachment: local;
    background-size: cover;
    height: get_vw(calc_retina3(225));
    margin: 0 auto get_percent(calc_retina3(45px));
    padding-top: get_percent(18px);
    position: relative;
    width: get_percent(calc_retina3(801px));

    @include mq_pc {
      height: 75px;
    }
  }

  &__textarea {
    background: rgba(0, 0, 0, 0);
    color: #FFF;
    display: block;
    font-size: 1.0rem;
    @include fontVw(10);
    height: get_vw(56);
    margin: 0 auto get_percent(calc_retina3(45px), calc_retina3(801px));
    letter-spacing: 0.8vw;
    line-height: 1.8;
    overflow-wrap: break-word;
    padding: 0 get_percent(11px, calc_retina3(801px));
    resize: none;
    width: 100%;
    
    @include mq_pc {
      font-size: 1.0rem;
      height: 56px;
      letter-spacing: 0.4rem;
    }
  }

  &__text-error--0 {
    margin: get_percent(6px) auto 0;
    width: get_percent(calc_retina3(577px), calc_retina3(801px));
  }
  &__text-error--1 {
    margin: get_percent(6px) auto 0;
    width: get_percent(calc_retina3(614px), calc_retina3(801px));
  }

  &__btns {
    display: flex;
    justify-content: space-between;
    margin: 0 auto get_percent(calc_retina3(48px));
    width: get_percent(calc_retina3(1000px));
  }

  &__btn {
    &--0 {
      width: get_percent(calc_retina3(330px), calc_retina3(1000px));
    }
    &--1 {
      width: get_percent(calc_retina3(340px), calc_retina3(1000px));
    }
    &--clear {
      width: get_percent(calc_retina3(270px), calc_retina3(1000px));
    }
  }

  &__deco {
    &--1 {
      left: 0;
      margin-top: get_percent(145px);
      position: absolute;
      top: 0;
      width: get_percent(calc_retina3(186px));
      z-index: 5;
    }
    &--2 {
      position: absolute;
      right: 0;
      top: 0;
      width: get_percent(calc_retina3(220px));
      z-index: 5;
    }
  }

  &__enter {
    margin-bottom: get_percent(calc_retina3(57px));
  }

  .fade-enter-active {
    transition: all .4s ease-in-out;
    opacity: 0;
  }
  .fade-leave-active {
    transition: all .3s ease-in-out;
    opacity: 0;
  }
  .fade-enter-to {
    opacity: 1;
  }

  .anime {
    background-position-x: center;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    left: 0;
    max-width: 750px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 200;

    @include mq_pc {
      // inset: 0;
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
      max-width: 390px;
    }

    &__inner {
      align-items: center;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      margin-top: get_percent(-96px);
      width: 100%;
    }

    &__comics-wrap {
      align-items: center;
      display: flex;
      justify-content: center;
      margin-bottom: get_percent(calc_retina3(82px));
      position: relative;
      width: 100%;
    }

    &__comics {
      height: 0;
      padding-bottom: get_percent(calc_retina3(1220px));
      position: relative;
      width: get_percent(calc_retina3(674px));
    }

    &__comic {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;

      &--1 {
        z-index: 1;
      }
      &--2 {
        z-index: 2;
      }
      &--3 {
        z-index: 3;
      }
      &--4 {
        z-index: 4;
      }
    }

    &__num-wrap {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 201;
    }

    &__num {
      top: 50%;
      left: 50%;
      position: absolute;
    }

    &__num--1 {
      margin-left: get_percent(90px);
      margin-top: get_percent(60px);
      width: get_percent(calc_retina3(149px));
    }

    &__num--2 {
      margin-left: get_percent(-160px);
      margin-top: get_percent(-260px);
      width: get_percent(calc_retina3(276px));
    }

    &__num--3 {
      margin-left: get_percent(80px);
      margin-top: get_percent(-280px);
      width: get_percent(calc_retina3(121px));
    }

    &__num--4 {
      margin-left: get_percent(100px);
      margin-top: get_percent(-110px);
      width: get_percent(calc_retina3(141px));
    }

    &__num--5 {
      margin-left: get_percent(-150px);
      margin-top: get_percent(110px);
      width: get_percent(calc_retina3(160px));
    }

    &__num--6 {
      margin-left: get_percent(-150px);
      margin-top: get_percent(20px);
      width: get_percent(calc_retina3(73px));
    }

    &__text {
      color: #FFF;
      font-size: 1.6rem;
    }
  }


  .error {
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 300;

    &__comic {
      padding-top: get_percent(150px);
      width: get_percent(calc_retina3(596px));
    }
  }
}

</style>
